var map = {
	"./alema.webp": 4068,
	"./alema_amendoim.webp": 9743,
	"./alema_branca.webp": 3612,
	"./alema_nozes.webp": 5190,
	"./alema_ovomaltine.webp": 5809,
	"./alema_sem_acucar.webp": 3277,
	"./ameixa.webp": 8847,
	"./amendoim_sem_acucar.webp": 537,
	"./banana.webp": 301,
	"./banoffee.webp": 2280,
	"./bombonzao.webp": 8750,
	"./brigadeiro.webp": 5666,
	"./brownie.webp": 1449,
	"./brownie_morango.webp": 7210,
	"./cafe.webp": 2930,
	"./caramelo.webp": 7375,
	"./cheesecake.webp": 3955,
	"./cheesecake_goiaba.webp": 973,
	"./cheesecake_nutella.webp": 8496,
	"./cheesecake_sem_acucar.webp": 3868,
	"./chocolatra.webp": 3389,
	"./damasco.webp": 6982,
	"./docedelicia.webp": 9110,
	"./domino.webp": 5892,
	"./donaana.webp": 3609,
	"./feitico.webp": 8246,
	"./gabriela.webp": 3543,
	"./limao.webp": 4240,
	"./maca.webp": 3635,
	"./maracuja.webp": 4218,
	"./menta.webp": 1167,
	"./mesclada.webp": 5325,
	"./morango.webp": 6151,
	"./mousse.webp": 3998,
	"./mousse_brigadeiro.webp": 5341,
	"./mousse_sem_acucar.webp": 8999,
	"./nozes.webp": 2050,
	"./paodemel.webp": 927,
	"./pontanegra.webp": 694,
	"./profiterolis.webp": 5846,
	"./redvelvet.webp": 2608,
	"./romeu.webp": 8045,
	"./seducao.webp": 8337,
	"./spumone.webp": 5169,
	"./tentacao.webp": 3016,
	"./tropical.webp": 2090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4693;